var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderResume',{attrs:{"solution":"wholesale","order":_vm.order}}),_c('v-checkbox',{attrs:{"color":"green","label":"Confirmo as informações do pedido","rules":[..._vm.required]},model:{value:(_vm.terms),callback:function ($$v) {_vm.terms=$$v},expression:"terms"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }